import './jquery.gridrotator';
import Vue from 'vue';

// Code-Splitting - Loads heroes data async (https://webpack.js.org/guides/code-splitting/)
import(/* webpackChunkName: "heroes" */ './heroes.json').then(({heroes}) => {

	var heroesApp = new Vue({
		el: '#heroes-app',
		data() {
			return {
				heroes: [],
				singleHero: null
			};
		},
		created: function () {
			var vm = this;
			vm.heroes = heroes;
		},
		methods: {
			view: function (heroId) {
				this.singleHero = this.heroes.find(function (hero) {
					return parseInt(hero.id) === parseInt(heroId);
				});
			},
			close: function (event) {
				if (event) event.preventDefault();
				this.singleHero = null;
			},
			filterLetters: function (heroes) {
				var lastLetters = [];
				heroes.forEach(hero => {
					let letter = hero.lastName.substring(0, 1);
					if (!lastLetters.find(e => e === letter)) {
						lastLetters.push(letter);
					}
				});
				return lastLetters;
			},
			filterByLetter: function (letter) {
				window.grid._layout(null, letter);
				window.grid._start();
			}
		}
	});

	$(document).ready(function () {
		window.grid = $('.gallery').gridrotator({
			// number of rows
			rows: 8,
			// number of columns
			columns: 7,
			w1024: { rows: 8, columns: 5 },
			w768: { rows: 8, columns: 3 },
			w480: { rows: 8, columns: 2 },
			// prevent user to click the items
			preventClick: false,
			animType: 'rotate3d'
		});

		$(document).on('click', '.view-hero', function (e) {
			e.preventDefault();
			var heroId = $(this).data('hero-id');
			heroesApp.view(heroId);
		});

		$(document).on('click', '.letter-filter', function () {
			$('.letter-filter').removeClass('active');
			$(this).addClass('active');
		});

		$('#sort-btn').click(function (e) {
			e.preventDefault();
			$('.letter-filter').removeClass('active');
			window.grid._layout(null, '/');
			window.grid._start();
		});
	});
});
